import { ItemMeasurementEnum } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'

export const measureNameValues = Object.values(ItemMeasurementEnum).map((value) => ({ value }))
